    $(function () {
        let body = $('#MainContent')

        let list = [
            'template--14459892465746__40beb2a2-f832-4728-a050-df34d782a4cb',
            'template--14459892465746__a44ac554-69d1-47fa-bb88-4cad29ebdc84'
        ]
        for (let i of list) {
            body.find(`div[data-section-id="${i}"]`).children().addClass('imgPadding')
        }
        
    });